import { render } from "./WalletHoldings.vue?vue&type=template&id=18273fd4"
import script from "./WalletHoldings.vue?vue&type=script&lang=js"
export * from "./WalletHoldings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletHoldings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18273fd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18273fd4', __exports__)) {
    api.reload('18273fd4', __exports__)
  }
  
  module.hot.accept("./WalletHoldings.vue?vue&type=template&id=18273fd4", () => {
    api.rerender('18273fd4', render)
  })

}


export default __exports__